module.exports = __webpack_public_path__ + "static/oboe_cn-706653787a811fb98a1a3a221e6126de.pdf";